import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lightgallery.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import LightGallery from "lightgallery/react";
import { useEffect, useState } from "react";
import { Col, Container, ListGroup, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ImageElement from "components/ImageElement";

import { BROKER_ENDPOINT } from "apiEndpoints";
import userRouteMap from "routes/User/userRouteMap";
import { commonService } from "services/common.service";
import socketEventManager from "socket/socketEvents";
import { removeBordersFromCursorPointerImages } from "utils/helpers";

function AmenitiesGallery() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Check if private mode is enabled
  const localValue = localStorage.getItem("privateMode");
  const isPrivateMode = localValue === "true";
  
  const [state, setState] = useState({
    isLoading: true,
    lists: [],
    activeChild: {},
    media: [],
    clildMedia: [],
  });
  const getPageDatails = async (id) => {
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(
          id || location.state.id
        ),
      });

      if (id) {
        return response?.data?.data;
      }
      setState({
        ...state,
        isLoading: false,
        lists: response?.data?.data ?? [],
        activeChild: {
          parentIndex: 0,
          childIndex: null,
        },
        clildMedia: response?.data?.data,
        media: response?.data?.data?.[0]
          ? (response.data?.data?.[0]?.child_category
            ?.map?.((item) => item?.media)
            ?.flat?.() ?? [])
          : [],
      });
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  const handleChangeOption = async (parentIndex, childIndex) => {
    removeBordersFromCursorPointerImages();
    let media = [];
    if (
      !state?.lists?.[parentIndex]?.child_category?.length &&
      !state[`media-${parentIndex}`]?.length
    ) {
      media = await getPageDatails(state?.lists?.[parentIndex]?.id);
    } else {
      media = state?.lists?.[parentIndex]?.child_category?.[childIndex]
        ? state?.lists?.[parentIndex]?.child_category?.[childIndex]?.media
        : typeof childIndex === "undefined"
          ? state[`media-${parentIndex}`]
          : state[`media-${parentIndex}-${childIndex}`];
    }
    setState((prevState) => {
      let obj = {
        ...prevState,
        activeChild: { parentIndex, childIndex },
        media,
      };

      if (typeof childIndex === "undefined") {
        obj[`media-${parentIndex}`] = media?.length
          ? media
          : typeof childIndex === "undefined"
            ? (prevState?.lists?.[parentIndex]?.child_category
              ?.map((item) => item?.media)
              ?.flat?.() ?? [])
            : (prevState?.lists?.[parentIndex]?.child_category?.[childIndex]
              ?.media ?? []);
      } else {
        obj[`media-${parentIndex}-${childIndex}`] = media?.length
          ? media
          : typeof childIndex === "undefined"
            ? (prevState?.lists?.[parentIndex]?.child_category
              ?.map((item) => item?.media)
              ?.flat?.() ?? [])
            : (prevState?.lists?.[parentIndex]?.child_category?.[childIndex]
              ?.media ?? []);
      }
      obj.media = media?.length
        ? media
        : typeof childIndex === "undefined"
          ? (prevState?.lists?.[parentIndex]?.child_category
            ?.map((item) => item?.media)
            ?.flat?.() ?? [])
          : (prevState?.lists?.[parentIndex]?.child_category?.[childIndex]
            ?.media ?? []);
      return obj;
    });
  };

  const handleSocketCommand = (item, thisImage) => {    
    console.log("item", item);

    if (thisImage) {
      removeBordersFromCursorPointerImages();
      // add border class to the image which is clicked
      thisImage.classList.add('bordered');
    }

    const object = {
      hardware_id: item?.hardware_id,
      broker_id: item?.broker_id,
      sub_sub_category_id: item?.sub_sub_category_id,
    }    
    if (item?.gallery_type === "image") {
      object.type = "gallery_image";
      object.image_id = item?.id;
      object.image_url = item?.image_name;
      socketEventManager.sendCommand(item?.hardware_id, object);
    }      
  }

 
  const handleOnLoadSocketCommand = (item) => { 
    const object = {
      hardware_id: item?.parent_category?.hardware_id,
      broker_id: item?.parent_category?.broker_id,
      sub_sub_category_id: item?.parent_category?.sub_sub_category_id,
      type : "gallery_image",
      image_id : item?.parent_category?.id,
      image_url : item?.parent_category?.category_image,
    }    
    socketEventManager.sendCommand(item?.parent_category?.hardware_id, object);
  } 
  const handleAfterSlide = (detail) => {
    const index = detail?.index; // The new slide index
    const item = state?.media?.[index];
    if (item) {
      // handleSocketCommand(item);
    }
  };
  useEffect(() => {
    if (!location.state) {
      navigate("/");
    } else {
      getPageDatails();
    }
  }, []);

  return (
    <>
      <div className="mainContent_inner pb-0 h-100vh">
        <Container fluid className="position-relative">
          <Link
            className="commonBack commonBack_topLeft text-uppercase d-block h-auto position-absolute z-1"
            onClick={() => navigate(-1)}
          >
            <em className="icon-back" />
            <span className="d-block">Back</span>
          </Link>
          <div className="row">
            <Col md={6} className=" pe-lg-5">
              <div className="imgGrid imgGrid-full position-relative d-flex flex-column align-items-center">
                <div
                  className={
                    !state.isLoading
                      ? "imgGrid_inner d-flex flex-column w-100"
                      : ""
                  }
                >
                  {state?.isLoading ? (
                    <div className="d-flex justify-content-center align-items-center m-auto">
                      <Spinner />
                    </div>
                  ) : !state?.isLoading && state?.media?.length > 0 ? (
                    isPrivateMode ? (
                      <LightGallery
                        elementClassNames="gallery-container row gx-2 gy-2"
                        speed={500}
                        mobileSettings={{
                          controls: true,
                          showCloseIcon: true,
                          download: true,
                        }}
                        plugins={[lgThumbnail, lgZoom]}
                        // onInit={() => handleOnLoadSocketCommand(state.lists[0])}
                        // onAfterOpen={() => handleOnLoadSocketCommand(state.lists[0])}
                        onAfterSlide={handleAfterSlide}
                      >
                        {state?.media?.map((item, index) => (
                          <a
                            key={index}
                            className="imgGrid_item  col-lg-4 col-6"
                            href={item?.image_name}
                          >
                            <div className="position-relative"
                              // onClick={() => handleSocketCommand(item)}
                              >
                              <ImageElement
                                imageFor="user"
                                previewSource={item?.thumb_name}
                                className="img-fluid"
                                alt="loung-room"
                              />
                              {item?.hasVideo && (
                                <div className="playIcon d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-play" />
                                </div>
                              )}
                            </div>
                            <h3 className="imgGrid_item_label text-uppercase mt-1">
                              {item?.title}
                            </h3>
                          </a>
                        ))}
                      </LightGallery>
                    ) : (
                      <div className="gallery-container row gx-2 gy-2">
                        {state?.media?.map((item, index) => (
                          <div
                            key={index}
                            className="imgGrid_item  col-lg-4 col-6 cursor-pointer"
                          >
                            <div className="position-relative"
                              >
                              <ImageElement
                                imageFor="user"
                                previewSource={item?.thumb_name}
                                className="img-fluid"
                                alt="loung-room"
                                onClick={(e) => handleSocketCommand(item, e.currentTarget)}
                              />
                              {item?.hasVideo && (
                                <div className="playIcon d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-play" />
                                </div>
                              )}
                            </div>
                            <h3 className="imgGrid_item_label text-uppercase mt-1">
                              {item?.title}
                            </h3>
                          </div>
                        ))}
                      </div>
                    )
                  ) : (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                      <ImageElement
                        imageFor="amenities"
                        previewSource="/amenitiesgallery.jpg"
                        onLoad={() => handleOnLoadSocketCommand(state.lists[0])}
                        className="img-fluid"
                        alt="amenities-gallery"
                      />
                    </div>
                  )}
                </div>
              </div>
            </Col>

            <Col
              md={6}
              className="position-md-relative d-flex flex-column align-items-center justify-content-between"
            >
              <div className="header w-100 d-flex align-items-center pe-1">
                <div className="header_title mx-auto">
                  <h1 className="mb-0">AMENITIES DISPLAY</h1>
                </div>
                <Link className="header_logo" to={userRouteMap.LANDING.path}>
                  <ImageElement
                    imageFor="user"
                    source="logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </Link>
              </div>
              <div className="d-flex flex-column justify-content-around align-items-center multiList multiList-active multiList-tab multiList-scrollable">
                <div
                  className={
                    !state.isLoading ? "text-center innerScroll px-3" : ""
                  }
                >
                  {state.isLoading ? (
                    <div className="d-flex justify-content-center align-items-center m-auto">
                      <Spinner />
                    </div>
                  ) : !state?.isLoading && state?.lists?.length > 0 ? (
                    <>
                      <h2 className="text-uppercase innerHead">GALLERY</h2>
                      <div className="landingPage_right_menu text-center innerScroll px-3">
                        <>
                          <ListGroup className="flex-column">
                            {state?.lists?.map((listItem, idx) => (
                              <ListGroup.Item
                                className="multiList_item"
                                key={idx}
                              >
                                <Link
                                  className={`multiList_item_tab ${state.activeChild?.parentIndex === idx
                                      ? "active-heading"
                                      : ""
                                    }`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleChangeOption(idx);
                                  }}
                                >
                                  {listItem.name}
                                </Link>

                                {listItem?.child_category?.length > 0 && (
                                  <div className="d-flex flex-wrap subList justify-content-center">
                                    {listItem.child_category.map(
                                      (childItem, childItemIdx) => (
                                        <Link
                                          to=""
                                          key={childItemIdx}
                                          className={`subList_tab ${state.activeChild?.parentIndex ===
                                              idx &&
                                              state.activeChild?.childIndex ===
                                              childItemIdx
                                              ? "active"
                                              : ""
                                            }`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleChangeOption(
                                              idx,
                                              childItemIdx
                                            );
                                          }}
                                        >
                                          {childItem.name}
                                        </Link>
                                      )
                                    )}
                                  </div>
                                )}
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                        </>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                      No data found
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="customSwitch d-flex align-items-center mb-2 pb-4">
                <label className="switch">
                  <input type="checkbox" />
                  <span className="slider" />
                </label>
                <span className="switchLabel">slideshow</span>
              </div> */}
            </Col>
          </div>
        </Container>
      </div>
    </>
  );
}

export default AmenitiesGallery;
